<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row">
                                <div class="col-10">
                                    <h2>Last Login History Date</h2>
                                </div>
                                <div class="col-2" style="justify-content: flex-end;">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">
                                <div style="max-height:500px;overflow-y:scroll">
                                    <table class="table table-borderless text-center" v-if="dataTable">
                                        <thead style="border-bottom:1px solid grey">
                                            <th>No.</th>
                                            <th>Username</th>
                                            <th>User Type</th>
                                            <th>Login Time</th>
                                        </thead>
                                        <tbody v-for="(singleData, index) in dataTable" :key="singleData.login_time" style="border-bottom:1px solid grey">
                                            <tr>
                                                <td>{{index + 1}}</td>
                                                <td>{{singleData.username}}</td>
                                                <td>{{singleData.type}}</td>
                                                <td>{{singleData.login_time}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    // import MultiSelect from 'vue-multiselect';
    
    export default {
        data() {
            return {
                dataTable : null
            }
        },
        props : ['data' , 'filter'],
        components : {
            // MultiSelect,
        },
        mounted() {
            this.loadApi ()
        },
        watch: {

        },
        methods: {
            async loadApi() {
                try {

                    let filter = this.filter
                    let url ='/api/user/userDashboardLogDetails?id=' + this.data.user_id + '&'
                    url = this.initialiseFilter(url , filter)
                    // url = this.initialiseFilter(url , this.data)

                    let resp = await this.$http.get(url)

                    this.dataTable = resp.data.data
                }
                catch(err) {
                    console.log(err)
                }
            }
        }
    }
</script>

<style>

</style>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        overflow: auto;
        min-height: 40vh;
        max-height: 80vh;
        max-width: 80vw;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    code {
        background-color: transparent;
        color: black;
    }

    pre {
        outline: 1px solid #ccc;
        padding: 5px;
        margin: 5px;
    }

    .stringHighlight {
        color: green;
    }

    .numberHighlight {
        color: darkorange;
    }

    .booleanHighlight {
        color: blue;
    }

    .nullHighlight {
        color: magenta;
    }

    .keyHighlight {
        color: red;
    }
</style>